<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 充电桩信息
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">刷新</button>
        </div>
        <div class="charging">
          <div class="pile" v-for="item in chargingArr" :key="item.id">
            <div class="pile_left">
              <div class="pile_left_l">
                <!-- 四个角的边框效果 -->
                <div class="border_corner border_corner_left_top"></div>
                <div class="border_corner border_corner_right_top"></div>
                <div class="border_corner border_corner_left_bottom"></div>
                <div class="border_corner border_corner_right_bottom"></div>
                <div class="main">
                  <span
                    class="back_icon iconfont iconnewchongdianzhuang"
                  ></span>
                  <span class="top_icon iconfont iconnewchongdianzhuang"></span>
                </div>
              </div>
              <div class="pile_left_r">
                <div class="pile_left_t">
                  <p>编码：{{ item.deviceCode }}</p>
                  <span
                    :class="[
                      item.state == 'online'
                        ? 'zaixian'
                        : item.state == 'offline'
                        ? 'lixian'
                        : 'nodata',
                    ]"
                    >{{
                      item.state == "online"
                        ? "在线"
                        : item.state == "offline"
                        ? "离线"
                        : "无信息"
                    }}</span
                  >
                </div>
                <div class="pile_left_b">
                  <span class="message">
                    <i class="iconfont iconmingcheng"></i>
                    <p>名称：{{ item.deviceName }}</p>
                  </span>
                  <span class="message">
                    <i class="iconfont icondizhi1"></i>
                    <p>地址：{{ item.address }}</p>
                  </span>
                  <span v-if="!item.disabled" class="status shiyong"
                    ><i class="iconfont iconyuanquan"></i>未禁用</span
                  >
                  <span v-else class="status jinyong"
                    ><i class="iconfont iconyuanquan"></i>禁用中</span
                  >
                </div>
              </div>
              <!-- 左右分界线样式 -->
              <div class="line_point"></div>
            </div>
            <div v-if="!item.state" class="right_nodata">暂无信息</div>
            <div v-else class="pile_right">
              <vueSeamless :data="item.plugList" :class-option="optionCustomer">
                <ul>
                  <li v-for="(i, index) in item.plugList" :key="index">
                    <span
                      :class="[i.state.value == 3 ? 'guzhang' : 'zhengchang']"
                    >
                      <img v-default-img v-if="i.state.value == 2" src="./充电中.png" />
                      <img v-default-img v-if="i.state.value == 1" src="./空闲.png" />
                      <img v-default-img v-if="i.state.value == 3" src="./异常.png" />
                      <p>
                        {{
                          i.state.value == 1
                            ? "设备空闲"
                            : i.state.value == 2
                            ? "充电中"
                            : "设备故障"
                        }}
                      </p>
                    </span>
                    <p>充电桩插头{{ i.plugId }}</p>
                  </li>
                </ul>
              </vueSeamless>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import vueSeamless from "vue-seamless-scroll";
export default {
  data() {
    return {
      tabName: "jsgl",
      chargingArr: [],
      optionCustomer: {
        step: 1,
        limitMoveNum: 5,
        openTouch: false,
        waitTime: 1,
        direction: 2,
        singleWidth: 30,
      },
    };
  },
  components: {
    vueSeamless,
  },
  methods: {
    //刷新
    subSeefrom() {
      this.initCharging();
    },
    initCharging() {
      this.$axiosget("extra/chargingPile/findAllDeviceInfo").then((res) => {
        this.chargingArr = res.data.data;
      });
    },
  },
  mounted() {
    this.initCharging();
  },
};
</script>

<style lang="less" scoped>
.content {
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
  }
  .charging {
    width: 100%;
    height: 100%;
    padding-top: 20px;
    .pile {
      width: calc(100% - 40px);
      height: 100%;
      display: flex;
      flex-direction: row;
      margin: 0 25px 20px 15px;
      padding: 30px 0 20px;
      background-color: #1c2035;
      .pile_left {
        width: 490px;
        height: 180px;
        padding: 10px 30px 30px;
        border-right: 1px solid #1d3668;
        position: relative;
        .line_point {
          width: 2px;
          height: 8px;
          background-color: #35b9f7;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 10;
        }
        .pile_left_l {
          float: left;
          width: 92px;
          height: 140px;
          position: relative;
          .main {
            width: 100%;
            height: 100%;
            position: relative;
            border: 1px solid transparent;
            //   background-color: #212a4d;
            background-image: linear-gradient(#212948, #23347c);
            .iconfont {
              font-size: 90px;
              position: absolute;
              top: 50%;
              left: 50%;
            }
            .top_icon {
              color: #167ae0;
              transform: translate(-55%, -45%);
            }
            .back_icon {
              color: #1d4b8b;
              transform: translate(-50%, -50%);
            }
          }
          .border_corner {
            z-index: 2500;
            position: absolute;
            width: 4px;
            height: 4px;
            background: rgba(0, 0, 0, 0);
            border: 1px solid #35b9f7;
          }
          .border_corner_left_top {
            top: 0;
            left: 0;
            border-right: none;
            border-bottom: none;
          }
          .border_corner_right_top {
            top: 0;
            right: 0;
            border-left: none;
            border-bottom: none;
          }
          .border_corner_left_bottom {
            bottom: 0;
            left: 0;
            border-right: none;
            border-top: none;
          }
          .border_corner_right_bottom {
            bottom: 0;
            right: 0;
            border-left: none;
            border-top: none;
          }
        }
        .pile_left_r {
          float: left;
          height: 140px;
          margin: 0 0 0 17px;
          .pile_left_t {
            font-size: 14px;
            vertical-align: center;
            p {
              display: inline-block;
              width: 225px;
              height: 25px;
              padding-left: 10px;
              color: #00c0d4;
              background-color: #262e51;
              margin-bottom: 8px;
            }
            span {
              margin-left: 6px;
              padding: 0 15px;
              color: #fff;
              border-radius: 10px;
            }
            .zaixian {
              background-color: #009245;
            }
            .lixian {
              background-color: grey;
            }
            .nodata {
              background-color: red;
            }
          }
          .pile_left_b {
            width: 315px;
            padding: 15px 10px;
            background-color: #212740;
            .message {
              display: block;
              width: 100%;
              font-size: 14px;
              margin-bottom: 7px;
              white-space: nowrap;
              overflow: hidden;
              i {
                color: #2371d6;
              }
              p {
                display: inline-block;
                color: #648bb8;
              }
            }
            .status {
              display: inline-block;
              width: 63px;
              height: 25px;
              font-size: 12px;
              margin-right: 5px;
              line-height: 25px;
              text-align: center;
              color: #b1c5dd;
            }
            .shiyong {
              background: linear-gradient(to left, #1585ef, #1585ef) left top
                  no-repeat,
                linear-gradient(to bottom, #1585ef, #1585ef) left top no-repeat,
                linear-gradient(to left, #1585ef, #1585ef) right top no-repeat,
                linear-gradient(to bottom, #1585ef, #1585ef) right top no-repeat,
                linear-gradient(to left, #1585ef, #1585ef) left bottom no-repeat,
                linear-gradient(to bottom, #1585ef, #1585ef) left bottom
                  no-repeat,
                linear-gradient(to left, #1585ef, #1585ef) right bottom
                  no-repeat,
                linear-gradient(to left, #1585ef, #1585ef) right bottom
                  no-repeat,
                #2d3661;
              /*设置大小*/
              background-size: 2px 2px, 2px 2px, 2px 2px, 2px 2px, 2px 2px,
                2px 2px, 2px 2px, 2px 2px;
              i {
                color: #1585ef;
                font-weight: bold;
                font-size: 10px;
              }
            }
            .jinyong {
              background: linear-gradient(to left, #ce2048, #ce2048) left top
                  no-repeat,
                linear-gradient(to bottom, #ce2048, #ce2048) left top no-repeat,
                linear-gradient(to left, #ce2048, #ce2048) right top no-repeat,
                linear-gradient(to bottom, #ce2048, #ce2048) right top no-repeat,
                linear-gradient(to left, #ce2048, #ce2048) left bottom no-repeat,
                linear-gradient(to bottom, #ce2048, #ce2048) left bottom
                  no-repeat,
                linear-gradient(to left, #ce2048, #ce2048) right bottom
                  no-repeat,
                linear-gradient(to left, #ce2048, #ce2048) right bottom
                  no-repeat,
                #2d3661;
              /*设置大小*/
              background-size: 2px 2px, 2px 2px, 2px 2px, 2px 2px, 2px 2px,
                2px 2px, 2px 2px, 2px 2px;
              i {
                color: #ce2048;
                font-weight: bold;
                font-size: 10px;
              }
            }
          }
        }
      }
      .right_nodata {
        color: #b1c5dd;
        line-height: 175px;
        margin-left: 40px;
      }
      .pile_right {
        width: calc(100% - 550px);
        padding: 7px 0;
        margin-left: 30px;
        overflow: hidden;
        ul {
          width: 100%;
          display: flex;
          flex-direction: row;
          li {
            margin-right: 15px;
            span {
              display: inline-block;
              width: 137px;
              height: 137px;
              background-color: #262e51;
              text-align: center;
              border-radius: 3px;
              img {
                margin: 20px 0 5px;
              }
              p {
                color: #b1c5dd;
                font-size: 14px;
              }
            }
            .guzhang {
              border: 1px solid #ff1e1e;
            }
            p {
              margin-top: 7px;
              text-align: center;
              color: #b1c5dd;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/chargingStation/index.vue